import { Box, Container, Typography, Paper, List, ListItem } from '@mui/material';
import { motion } from 'framer-motion';

const Vision = () => {
  return (
    <Box sx={{ py: 8, backgroundColor: '#fff' }}>
      <Container maxWidth="lg">
        {/* Vision Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <Paper elevation={3} sx={{ p: 4, mb: 4, borderRadius: 2 }}>
            <Typography variant="h4" sx={{ mb: 3, color: '#1a237e' }}>
              The Vision
            </Typography>
            <Typography variant="body1" sx={{ mb: 4, lineHeight: 1.8 }}>
              We dream of a world where traders can laugh through the losses and celebrate the wins with a wink. 
              Mummy and Daddy Coins are here to remind you that trading is as much about the journey as the destination. 
              Picture this: a community of traders swapping Mummy Coins during a market crash for moral support, 
              or tossing Daddy Coins around when a bold call pays off. It's not just a coin—it's a vibe.
            </Typography>
          </Paper>
        </motion.div>

        {/* How It Works Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
        >
          <Paper elevation={3} sx={{ p: 4, mb: 4, borderRadius: 2 }}>
            <Typography variant="h4" sx={{ mb: 3, color: '#1a237e' }}>
              How It Works
            </Typography>
            <List>
              <ListItem sx={{ display: 'block', mb: 2 }}>
                <Typography variant="h6" sx={{ color: '#ff4081', mb: 1 }}>
                  Mummy Coin
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  Grab some Mummy Coins to channel that protective energy when the market gets scary. 
                  Share them with your trading buddies when the Dow takes a dive or when your crypto 
                  wallet feels like a haunted house.
                </Typography>
              </ListItem>
              <ListItem sx={{ display: 'block' }}>
                <Typography variant="h6" sx={{ color: '#f50057', mb: 1 }}>
                  Daddy Coin
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  Snag Daddy Coins to flex your confidence when you're feeling bullish or bearish. 
                  It's the perfect way to say, "I'm in—come to Daddy!" as you place your bet on 
                  the market's next move.
                </Typography>
              </ListItem>
            </List>
          </Paper>
        </motion.div>

        {/* Call to Action Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          viewport={{ once: true }}
        >
          <Paper elevation={3} sx={{ p: 4, mb: 4, borderRadius: 2 }}>
            <Typography variant="h4" sx={{ mb: 3, color: '#1a237e' }}>
              A Call to Action
            </Typography>
            <Typography variant="body1" sx={{ mb: 4, lineHeight: 1.8 }}>
              To all the traders out there staring at red screens or celebrating green candles: 
              Mummy and Daddy Coins are for you. They're for the late-night chart watchers, 
              the coffee-fueled day traders, and everyone who's ever felt the market's wild ride. 
              Join us in this lighthearted rebellion against the stress of trading. Grab your 
              Mummy Coins for comfort, your Daddy Coins for confidence, and let's make the markets 
              a little less serious, one coin at a time.
            </Typography>
            <Typography variant="body2" sx={{ mb: 4, fontStyle: 'italic', color: '#666' }}>
              Disclaimer: Mummy and Daddy Coins are all about fun, not financial advice. 
              The market's a wild place—trade responsibly, laugh generously, and always keep 
              your sense of humor handy.
            </Typography>
            <Typography variant="h5" sx={{ textAlign: 'center', color: '#1a237e', fontWeight: 'bold' }}>
              Come to Mummy, Come to Daddy—Let's Trade with some laughs!
            </Typography>
          </Paper>
        </motion.div>
      </Container>
    </Box>
  );
};

export default Vision;
